(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["polaroid-stack"] && !Shopify.designMode) return;
  try {
    function pyPolaroidsInitSwap(root) {
    if (!root || root.dataset.swapReady === '1') return;
    const frames = Array.from(root.querySelectorAll('.py-polaroids__frame'));
    if (frames.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    root.dataset.swapReady = '1';
    const isFan = root.classList.contains('py-polaroids--fan');
    const n = frames.length;
    /* Fan looks best with the rightmost card featured first. */
    let index = isFan ? n - 1 : 0;
    const ms = Number(root.dataset.swapMs) || 3500;

    const apply = () => {
      frames.forEach((frame, i) => {
        const front = i === index;
        frame.classList.toggle('is-front', front);
        /* Keep left→right resting order so the fan silhouette stays readable. */
        frame.style.zIndex = front ? String(n + 5) : String(1 + i);
      });
      index = (index + 1) % n;
    };

    apply();
    window.setInterval(apply, ms);
  }

  function pyPolaroidsBoot(scope) {
    const root = scope || document;
    root.querySelectorAll('.py-polaroids--swap').forEach(pyPolaroidsInitSwap);
  }

  pyPolaroidsBoot();
  document.addEventListener('shopify:section:load', (event) => {
    pyPolaroidsBoot(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
